// src/App.js

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Quiz from './components/Quiz'; // <-- हमारा क्विज़ प्लेयर
import './App.css';

// यह पेज तब दिखेगा जब कोई गलत ID डालेगा
function InvalidQuiz() {
  return (
    <div className="App">
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Invalid Quiz ID</h1>
        <p>Please check the link and try again.</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 1. http://localhost:3000/quiz/SOME_ID
             यह :quizId को पकड़ेगा और Quiz कंपोनेंट को देगा
        */}
        <Route path="/quiz/:quizId" element={<Quiz />} />
        
        {/* 2. http://localhost:3000/
             (या कोई भी और लिंक) यह पेज दिखाएगा
        */}
        <Route path="*" element={<InvalidQuiz />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;